"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = (0, _getPrototypeOf2.default)(derived);
  return (0, _possibleConstructorReturn2.default)(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], (0, _getPrototypeOf2.default)(_this).constructor) : derived.apply(_this, args));
}
var Unauthenticated = /*#__PURE__*/function (_Error) {
  function Unauthenticated(message) {
    var _this2;
    (0, _classCallCheck2.default)(this, Unauthenticated);
    _this2 = _callSuper(this, Unauthenticated, [message]);
    (0, _defineProperty2.default)(_this2, "loginType", void 0);
    _this2.name = 'FunkeUnauthenticated';
    _this2.loginType = '';
    return _this2;
  }
  (0, _inherits2.default)(Unauthenticated, _Error);
  return (0, _createClass2.default)(Unauthenticated);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
var _default = exports.default = Unauthenticated;